document.addEventListener('DOMContentLoaded', function () {
    const productContainer = document.querySelector('.product');
    if (!productContainer) return;

    // Listen for the custom variant change event dispatched by global.js
    document.addEventListener('variant:change', function (event) {
        const variant = event.detail.variant;
        if (!variant) return;

        updateWhatsAppButtons(variant);
        updateFreightButton(variant);
    });

    function updateWhatsAppButtons(variant) {
        const whatsappButton = document.querySelector('.product__whatsapp-button');
        if (!whatsappButton) return;

        // Get the base message template from data attribute
        const baseMessage = whatsappButton.dataset.messageTemplate || '';
        const phoneNumber = whatsappButton.dataset.phone || '5531997926156';

        // Construct the new message
        // We expect the template to have placeholders or we reconstruct it
        // To match the Liquid template:
        // Olá! Tenho interesse no seguinte produto:
        // *{{ product.title }}*
        // {% if product.selected_or_first_available_variant.title != 'Default Title' %}Variante: {{ product.selected_or_first_available_variant.title }}{% endif %}
        // Preço: {{ product.selected_or_first_available_variant.price | money }}
        // Gostaria de mais informações para finalizar a compra.

        // Since we can't easily parse Liquid in JS, we rely on data attributes provided by Liquid for the static parts
        // and replace the dynamic parts.

        const productTitle = whatsappButton.dataset.productTitle;
        let variantTitle = '';
        if (variant.title && variant.title !== 'Default Title') {
            variantTitle = `Variante: ${variant.title}`;
        }

        // Format price
        const price = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(variant.price / 100);

        const newMessage = `Olá! Tenho interesse no seguinte produto:

*${productTitle}*
${variantTitle}
Preço: ${price}

Gostaria de mais informações para finalizar a compra.`.trim();

        const encodedMessage = encodeURIComponent(newMessage);
        const newUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

        whatsappButton.href = newUrl;
    }

    function updateFreightButton(variant) {
        const freightButton = document.querySelector('.product__frete-button');
        if (!freightButton) return;

        const phoneNumber = freightButton.dataset.phone || '5531997926156';
        const productTitle = freightButton.dataset.productTitle;

        let variantTitle = '';
        if (variant.title && variant.title !== 'Default Title') {
            variantTitle = `Variante: ${variant.title}`;
        }

        const newMessage = `Olá! Gostaria de saber o valor do frete para o seguinte produto:

*${productTitle}*
${variantTitle}

Aguardo retorno com o valor do frete. Obrigado!`.trim();

        const encodedMessage = encodeURIComponent(newMessage);
        const newUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

        freightButton.href = newUrl;
    }
});
